var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Inset, Stack } from "syf-component-library/ui/spacing";
import { useTranslation } from "react-i18next";
import { Grid } from "syf-component-library/ui/patterns";
import VantageTrans from "../../../atoms/VantageTrans";
import { BulletListWrapper, CreditTipCardWrapper, TipCardHeader, } from "./subcomponents";
var CreditTipCard = function () {
    var t = useTranslation().t;
    var tipColumnOne = t("creditScorePage.tipColumnOne", {
        returnObjects: true,
    });
    var tipColumnTwo = t("creditScorePage.tipColumnTwo", {
        returnObjects: true,
    });
    return (_jsxs(_Fragment, { children: [_jsxs(CreditTipCardWrapper, { children: [_jsx(Stack, { size: "small" }), _jsx(TipCardHeader, __assign({ as: "h2", weight: "bold" }, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.headers.tips" }) })), _jsx(Stack, { size: "medium" }), _jsxs(Grid, { children: [_jsx(BulletListWrapper, { children: tipColumnOne.map(function (tip, index) {
                                    return (_jsx("li", { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.tipColumnOne.".concat(index) }) }, "credit-tip-column-one-".concat(tip)));
                                }) }), _jsx(BulletListWrapper, { children: tipColumnTwo.map(function (tip, index) {
                                    return (_jsx("li", { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.tipColumnTwo.".concat(index) }) }, "credit-tip-column-two-".concat(tip)));
                                }) })] }), _jsx(Stack, { size: "medium" }), _jsx(Inset, __assign({ top: "xsmall", left: "small", right: "small", bottom: "large" }, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.tipModal.summary" }) }))] }), _jsx(Stack, { size: "xxlarge" })] }));
};
export default CreditTipCard;
